module.exports = __webpack_public_path__ + "img/love-it-ribbon-2.ae15ac99.svg";